import $ from 'jquery'
import Overlay from 'ol/Overlay'
import Select from 'ol/interaction/Select'
import Tool from '../Tool'
import { unByKey } from 'ol/Observable'
import { Coordinate } from 'ol/coordinate'
import { isInvisibleLayer } from '../ol'

/**
 * Delete tool class
 *
 * @param {Object} config
 * @constructor
 */
export default class Delete extends Tool {
  constructor(config) {
    super()

    $.extend(this, config)

    this.ui.iconClass = 'fa fa-times'

    this.$popover = $('#delete-tool-popover')
    this.$buttonDelete = this.$popover.find('#delete-confirm')
    this.$buttonCancel = this.$popover.find('#delete-cancel')

    this.$buttonCancel.on('click', this.handleDeleteCancel.bind(this))
    this.$buttonDelete.on('click', this.handleDeleteConfirm.bind(this))

    var popupOffset = this.popoverGetOffset()

    this.popoverOverlay = new Overlay({
      element: this.$popover.get(0),
      offset: [popupOffset.x, popupOffset.y]
    })

    this.select = new Select({
      layers: function(layer) {
        var olgaProperties = layer.get('olga_')
        if (
          (olgaProperties &&
            olgaProperties.metadata &&
            olgaProperties.metadata.select === false) ||
          isInvisibleLayer(layer)
        ) {
          return false
        }

        return true
      }
    })
    this.removeTrigger = this.api.draw.createTrigger()

    this.map.addOverlay(this.popoverOverlay)
    this.events = []
    this.enableToggle = true
  }

  /**
   * Activate delete tool
   */
  activate() {
    this.deselectAllFeatures()
    this.events = [this.map.on('click', this.handleMapClick.bind(this))]
    this.map.addInteraction(this.select)
    super.activate()
  }

  /**
   * Deactivate delete tool and removes event listeners
   */
  deactivate() {
    this.events.forEach(e => unByKey(e))
    this.events = []
    this.map.removeInteraction(this.select)
    super.deactivate()
  }
}

/**
 * Callback for map click events
 * @param {Event} e
 */
Delete.prototype.handleMapClick = function(e) {
  this.popoverHide()
  this.popoverSetPosition(e.coordinate)

  var onSelectEventKey = this.select
    .getFeatures()
    .on('change:length', this.handleSelectedFeature.bind(this))
  this.events.push(onSelectEventKey)
}

/**
 * Deselects all features
 */
Delete.prototype.deselectAllFeatures = function() {
  this.select.getFeatures().clear()
}

/**
 * Delete cancel button callback
 */
Delete.prototype.handleDeleteCancel = function() {
  this.popoverHide()
  this.deselectAllFeatures()
}

/**
 * Delete confirm button callback
 */
Delete.prototype.handleDeleteConfirm = function() {
  this.deleteSelectedFeatures()
  this.popoverHide()
}

/**
 * Selected feature callback
 * @param {Event} e
 */
Delete.prototype.handleSelectedFeature = function(e) {
  if (e.target.getArray().length > 0) {
    this.popoverShow()
  }
}

/**
 * Delete selected features
 */
Delete.prototype.deleteSelectedFeatures = function() {
  var features = this.select.getFeatures()

  features.forEach(feature => {
    this.map.getLayers().forEach(layer => {
      var source = layer.getSource()

      if (source.removeFeature && source.getFeatures().length > 0) {
        try {
          source.removeFeature(feature)
          this.removeTrigger({
            type: 'remove',
            feature: feature
          })
        } catch (e) {}
      }
    })
  })

  features.clear()
}

/**
 * Set the popover position
 * @param {Coordinate} coordinate
 */
Delete.prototype.popoverSetPosition = function(coordinate) {
  this.popoverOverlay.setPosition(coordinate)
}

/**
 * Show popover
 */
Delete.prototype.popoverShow = function() {
  this.$popover.show()
}

/**
 * Hide popover
 */
Delete.prototype.popoverHide = function() {
  this.$popover.hide()
}

/**
 * Get popover offset based on popover sice to get the arrow to point on the selected coordinate
 * @return {Object} Offset
 */
Delete.prototype.popoverGetOffset = function() {
  var offset = {
    x: this.$popover.width() / -2,
    y: this.$popover.height() * -1
  }
  return offset
}
